import React from 'react';
import { Box } from '@itandi/itandi-bb-ui';
import Styles from './statuses.module.scss';
import { useDealEstimations } from '~/hooks/deals/useDealEstimations';
import { useDealInspectionReportImages } from '~/hooks/deals/useDealInspectionReportImages';
import { ReportImageNavigation } from '~/components/common/reports/navigation/ReportImageNavigation';
import { PATH as INSPECTION_REPORT_PATH } from '~/pages/deals/[id]/inspection_reports';
import { UploadFileNavigation } from '~/components/common/upload_files/UploadFileNavigation';
import { StatusHandleClientButtons } from '~/components/common/statuses/StatusHandleClientButtons';
import {
  IN_CONSTRUCTION,
  IN_ESTIMATION,
  SEND_ESTIMATE,
  statusMovingValidation
} from '~/models/Status';
import type { DealUploadFile } from '~/models/DealUploadFile';
import { getFilePath as getClientFilePath } from '~/utils/api/deals/DealUploadedFile';
import { matchDealType, ESTIMATION_BY } from '~/models/Deal';
import { getOriginVendor } from '~/models/DealVendorCompany';
import { useDealEstimationHeaders } from '~/hooks/deals/useDealEstimationHeaders';
import { ConstructionClientNavigation } from '~/components/common/constructions/navigation/ConstructionClientNavigation';
import { useDealContext } from '~/context/DealContext';

export const SendEstimate: React.FC = () => {
  const deal = useDealContext();
  const { data: dealEstimationContext } = useDealEstimations().index(deal.id);
  const { data: dealEstimationHeaders } = useDealEstimationHeaders().index(
    deal.id
  );
  const reportsApi = useDealInspectionReportImages();
  const { data: reportImages } = reportsApi.index(deal.id);
  const allowPartiallyFinish = React.useMemo(() => {
    const originVendor = getOriginVendor(deal);
    return originVendor !== null && originVendor.allowPartiallyFinished;
  }, [deal]);
  const forwardStatusDisabled =
    !dealEstimationHeaders ||
    !dealEstimationContext ||
    !statusMovingValidation[SEND_ESTIMATE](
      dealEstimationHeaders,
      dealEstimationContext,
      true
    );
  const handleGetMemorandumFilePath = (file: DealUploadFile): string =>
    getClientFilePath(deal.id, file);
  return (
    <div>
      <h3 className={Styles.Title}>{`${
        matchDealType(deal, 'restoration') ? '退去' : ''
      }立会が完了しました`}</h3>
      <Box marginY={16}>
        <p className={Styles.Description}>
          立会報告画像・見積りを確認後、ステータスを進めてください。
          <br />
          未確定の見積り申請がある場合、ステータスを進めることができません。
        </p>
      </Box>
      {reportImages !== null && (
        <ReportImageNavigation
          detailPageButtonLabel="画像確認画面"
          detailPagePath={INSPECTION_REPORT_PATH(deal.id)}
          reportImages={reportImages}
          title={`${
            matchDealType(deal, 'repair') ? '現地調査の' : '立会報告'
          }画像を確認してください`}
        />
      )}
      <ConstructionClientNavigation title="見積りを確認してください" />
      {deal.dealMemorandumFiles.length > 0 && (
        <UploadFileNavigation
          deal={deal}
          files={deal.dealMemorandumFiles}
          fileType="賃借人同意書"
          handleGetFilePath={handleGetMemorandumFilePath}
          title="賃借人同意書を確認してください"
        />
      )}
      <StatusHandleClientButtons
        alertText="確定ボタンを押すと工事の手配へ移ります。"
        allowPartiallyFinish={allowPartiallyFinish}
        forwardDisabled={forwardStatusDisabled}
        nextStatusId={IN_CONSTRUCTION}
        prevStatusId={
          deal.estimationBy === ESTIMATION_BY.COMPANY ? IN_ESTIMATION : null
        }
      />
    </div>
  );
};
